import { render } from "./ProjectRegisterview.vue?vue&type=template&id=798e61de&scoped=true"
import script from "./ProjectRegisterview.vue?vue&type=script&lang=js"
export * from "./ProjectRegisterview.vue?vue&type=script&lang=js"

import "./ProjectRegisterview.vue?vue&type=style&index=0&id=798e61de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798e61de"]])

export default __exports__